import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../contexts/i18n';

import type { TranslationKey } from '@shared/constants/translations';
import type { CugPrice } from '@shared/types/frontend/hotel-card';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './SavingsItem.module.scss';

const cls = cssModules(STYLES);

type Props = {
  cug: CugPrice;
  i18n: I18nService;
};

const CUG_TRANSLATE_MAP: { [key: string]: TranslationKey } = {
  logged_in: 'PriceBreakDown_PriceItem_LoggedInPriceApplied',
  mobile: 'PriceBreakDown_PriceItem_MobilePriceApplied',
};

const SavingsItem = ({ cug, i18n: { translate } }: Props) => {
  const cugNameKey = CUG_TRANSLATE_MAP[cug.type];
  const { discountPercentage } = cug;
  return (
    <div className={cls('SavingsItem__cugText')}>
      <BpkText textStyle={TEXT_STYLES.label1} color={TEXT_COLORS.textError}>
        {translate('PriceBreakDown_PriceItem_Savings')}
      </BpkText>
      <BpkText
        textStyle={TEXT_STYLES.footnote}
        color={TEXT_COLORS.textSecondary}
      >
        {cugNameKey
          ? translate(cugNameKey, {
              discountPercentage,
            })
          : translate('PriceBreakDown_PriceItem_DIscount_Applied', {
              discountPercentage,
            })}
      </BpkText>
    </div>
  );
};

export default withI18n(SavingsItem);
